import * as CONST from '@Bootstraps/bootstrapConstants';
import initialStates from '@Bootstraps/bootstrapInitialStates';

export default function rootReducer(state = initialStates, action) {
  const { type, payload } = action;

  const actions = {
    [CONST.SET_AUTH]: () => ({
      ...state,
      accessToken: payload,
    }),
    [CONST.SET_CART]: () => ({
      ...state,
      cart: payload,
    }),
    
    [CONST.REGISTRATION]: () => ({
      ...state,
      registrationLoading: true,
      registrationParams: payload,
      action: type,
    }),
    [CONST.REGISTRATION_FAILED]: () => ({
      ...state,
      registrationLoading: false,
      registrationError: payload,
      action: type,
    }),
    [CONST.REGISTRATION_SUCCESS]: () => ({
      ...state,
      registrationLoading: false,
      registrationResponse: payload,
      action: type,
    }),

    [CONST.LOGIN]: () => ({
      ...state,
      loginLoading: true,
      loginParams: payload,
      action: type,
    }),
    [CONST.LOGIN_FAILED]: () => ({
      ...state,
      loginLoading: false,
      loginError: payload,
      action: type,
    }),
    [CONST.LOGIN_SUCCESS]: () => ({
      ...state,
      loginLoading: false,
      loginResponse: payload,
      action: type,
    }),

    [CONST.REMOVE_ACCOUNT]: () => ({
      ...state,
      removeAccountLoading: true,
      removeAccountParams: payload,
      action: type,
    }),
    [CONST.REMOVE_ACCOUNT_FAILED]: () => ({
      ...state,
      removeAccountLoading: false,
      removeAccountError: payload,
      action: type,
    }),
    [CONST.REMOVE_ACCOUNT_SUCCESS]: () => ({
      ...state,
      removeAccountLoading: false,
      removeAccountResponse: payload,
      action: type,
    }),

    [CONST.CLOTHES_INQUIRY]: () => ({
      ...state,
      clothesInquiryLoading: true,
      clothesInquiryParams: payload,
      action: type,
    }),
    [CONST.CLOTHES_INQUIRY_FAILED]: () => ({
      ...state,
      clothesInquiryLoading: false,
      clothesInquiryError: payload,
      action: type,
    }),
    [CONST.CLOTHES_INQUIRY_SUCCESS]: () => ({
      ...state,
      clothesInquiryLoading: false,
      clothesInquiryResponse: payload,
      action: type,
    }),

    [CONST.CLOTHES_ENTITY]: () => ({
      ...state,
      clothesEntityLoading: true,
      clothesEntityParams: payload,
      action: type,
    }),
    [CONST.CLOTHES_ENTITY_FAILED]: () => ({
      ...state,
      clothesEntityLoading: false,
      clothesEntityError: payload,
      action: type,
    }),
    [CONST.CLOTHES_ENTITY_SUCCESS]: () => ({
      ...state,
      clothesEntityLoading: false,
      clothesEntityResponse: payload,
      action: type,
    }),

    [CONST.CLOTHES_INSERT]: () => ({
      ...state,
      clothesInsertLoading: true,
      clothesInsertParams: payload,
      action: type,
    }),
    [CONST.CLOTHES_INSERT_FAILED]: () => ({
      ...state,
      clothesInsertLoading: false,
      clothesInsertError: payload,
      action: type,
    }),
    [CONST.CLOTHES_INSERT_SUCCESS]: () => ({
      ...state,
      clothesInsertLoading: false,
      clothesInsertResponse: payload,
      action: type,
    }),

    [CONST.CLOTHES_UPDATE]: () => ({
      ...state,
      clothesUpdateLoading: true,
      clothesUpdateParams: payload,
      action: type,
    }),
    [CONST.CLOTHES_UPDATE_FAILED]: () => ({
      ...state,
      clothesUpdateLoading: false,
      clothesUpdateError: payload,
      action: type,
    }),
    [CONST.CLOTHES_UPDATE_SUCCESS]: () => ({
      ...state,
      clothesUpdateLoading: false,
      clothesUpdateResponse: payload,
      action: type,
    }),

    [CONST.CLOTHES_DELETE]: () => ({
      ...state,
      clothesDeleteLoading: true,
      clothesDeleteParams: payload,
      action: type,
    }),
    [CONST.CLOTHES_DELETE_FAILED]: () => ({
      ...state,
      clothesDeleteLoading: false,
      clothesDeleteError: payload,
      action: type,
    }),
    [CONST.CLOTHES_DELETE_SUCCESS]: () => ({
      ...state,
      clothesDeleteLoading: false,
      clothesDeleteResponse: payload,
      action: type,
    }),

    DEFAULT: () => state,
  };
  
  return (actions[type] || actions.DEFAULT)();
};